import { useScreenDetect } from '@sgcmpteltd/uikit-next';

import { Trigger as DesktopPtoTrigger } from './desktop';
import { Trigger as MobilePtoTrigger } from './mobile';
import type { Component } from './types';

export const Trigger: Component = ({
  onDesktopTrigger,
  onMobileTrigger,
}) => {
  const { isDesktop } = useScreenDetect();

  return !isDesktop()
    ? (
      <MobilePtoTrigger
        onTrigger={onMobileTrigger} />
    )
    : (
      <DesktopPtoTrigger
        onTrigger={onDesktopTrigger} />
    );
};
